<template>
  <div class="app-container" :class="{ 'selector-active': showSelector }">
    <router-view />
    <SelectorPage v-if="showSelector" @select-tble-biz="onSelectBiz" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import SelectorPage from './components/selector/SelectorPage.vue';
import { initTbleBizAnalytics } from './utils/analytics';

// [중간 분기 팝업 표시 중단 로직 ON/OFF]
const UTM_SELECTOR_SKIP_ENABLED = true;

const normalize = (value) => (value || '').trim().toLowerCase();

const getUtmEntries = () => {
  const params = new URLSearchParams(window.location.search);
  return Array.from(params.entries()).filter(([key]) =>
    normalize(key).startsWith('utm_')
  );
};

const hasNaverUtmValue = (utmEntries) =>
  utmEntries.some(([, value]) => normalize(value).includes('naver'));

const hasMatchingUtmValue = (utmEntries, targetKey, targetValue) =>
  utmEntries.some(
    ([key, value]) =>
      normalize(key) === targetKey && normalize(value) === targetValue
  );

const isSessionBizSelected = () => {
  try {
    return (
      sessionStorage.getItem('selected_service') === 'biz' ||
      sessionStorage.getItem('tble_biz_selected') === 'true'
    );
  } catch (e) {
    return false;
  }
};

const shouldSkipSelectorByUtm = () => {
  if (isSessionBizSelected()) return true;

  if (!UTM_SELECTOR_SKIP_ENABLED) return false;

  const utmEntries = getUtmEntries();
  if (utmEntries.length === 0) return false;
  if (hasNaverUtmValue(utmEntries)) return false;

  return (
    hasMatchingUtmValue(utmEntries, 'utm_source', 'meta') ||
    hasMatchingUtmValue(utmEntries, 'utm_medium', 'da')
  );
};

const pushBizSelectionEvent = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_service',
    service_name: 'biz',
    button_location: 'home_overlay',
  });
};

const skipSelector = shouldSkipSelectorByUtm();

if (skipSelector && !isSessionBizSelected()) {
  pushBizSelectionEvent();
}

const showSelector = ref(!skipSelector);

const onSelectBiz = () => {
  try {
    sessionStorage.setItem('selected_service', 'biz');
    sessionStorage.setItem('tble_biz_selected', 'true');
  } catch (e) {
    console.error('Failed to save to sessionStorage:', e);
  }
  showSelector.value = false;
};

onMounted(() => {
  initTbleBizAnalytics();
});
</script>

<style lang="scss">
@import './statics/scss/common.scss';

html, body {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

.app-container {
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  position: relative;

  &.selector-active {
    [data-testid="button-floating-contact"] {
      display: none !important;
    }
  }
}
</style>
